import Overflow from 'rc-overflow';
import { StyledBadge } from '../Badge/Badge.style';
import { styled } from '@mui/material';

export const StyledOverflow = styled(Overflow)`
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  max-width: 100%;
  position: relative;
  gap: 0.4615rem;
  white-space: nowrap;
  overflow: hidden;
`;

export const StyledOverflowItem = styled(StyledBadge)`
  flex: none;
  max-width: 100%;
`;
